import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { apiConfig } from 'config';
import { AuthService } from '_apis_/auth';

export default function jwtInterceptor() {
  const onRequest = (config: AxiosRequestConfig): AxiosRequestConfig => {
    // add auth header with jwt if account is logged in
    if (config.baseURL) {
      const { auth, user_mgt, asset_mgt, asset, site_energy, ocpi, ocpp, cpo, oadr, rfid } =
        apiConfig;
      if (
        [auth, user_mgt, asset_mgt, asset, site_energy, ocpi, ocpp, cpo, oadr, rfid].includes(
          config.baseURL
        )
      ) {
        const authService = new AuthService();
        const { authToken, refreshToken } = authService;
        if (config.headers) {
          if (authToken) Object.assign(config.headers, { Authorization: `Bearer ${authToken}` });
          if (refreshToken) {
            Object.assign(config.headers, { 'refresh-token': refreshToken });
          }
        }
      }
    }
    return config;
  };

  const onRequestError = (error: AxiosError): Promise<AxiosError> => {
    console.error(`[request error] [${JSON.stringify(error)}]`);
    return Promise.reject(error);
  };

  axios.interceptors.request.use(onRequest, onRequestError);
}
